var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"v-orb",style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),on:{"mouseenter":_vm.burst}},[_c('canvas',{ref:"canvas",attrs:{"width":_vm.size * 3,"height":_vm.size * 3}})])}
var staticRenderFns = []

export { render, staticRenderFns }